import LandingSection from 'components/landing/components/landing-section';
import PropTypes from 'prop-types';
import Spacer from 'core/spacer';
import Table from 'components/landing/discount/table';
import Text from 'core/text';
import Title from 'core/title';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';
import useRichTranslation from 'hooks/useRichTranslation';

const Discount = ({ data }) => {
    const { seoText, verification } = useGetSeoTextByIndex('discount');
    const t = useRichTranslation('discount-section');

    if (!verification || !data) {
        // TODO: Add sentry controlled error
        return null;
    }

    return (
        <LandingSection>
            <Title content={t('section_title')} />
            <Spacer />
            <Table data={data} />
            <Spacer />
            <Text content={`${seoText.paragraph1.sentence1} ${seoText.paragraph1.sentence2}`} />
            <Text content={`${seoText.paragraph2.sentence1} ${seoText.paragraph2.sentence2} ${seoText.paragraph2.sentence3}`} />
        </LandingSection>
    );
};

Discount.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            company: PropTypes.string,
            duration: PropTypes.string,
            value: PropTypes.string
        })
    ).isRequired
};

export default Discount;
